import { Delete, Edit, Invite } from './components';

const UsersManagementFlow = {
  Invite,
  Edit,
  Delete,
};

export { UsersManagementFlow };
